import React from 'react';
import PropTypes from 'prop-types';
import Util from 'utilities/helper.util';
import { Button, Tag } from 'carbon-components-react';
import { ChevronUp16, ChevronDown16, ZoomIn32 } from '@carbon/icons-react';
import { getEnquiryStatusCodeMsg } from 'appConstants/enquiry';

const PopUp: React.FC<Props> = (props) => {
  const { attributes, onButtonClick, isFullSet, geometry } = props;
  const handleButtonClick = () => {
    if (attributes?.objectid && typeof onButtonClick === 'function') {
      onButtonClick(attributes);
    }
  };

  const handleZoomIn = () => {
    const { loadedView } = window;
    if (!loadedView || loadedView.destroyed) return;

    if (geometry?.extent) {
      loadedView.goTo(geometry.extent).catch(() => {
        // Ignore AbortError during navigation
      });
    }
    if (loadedView.popup) {
      loadedView.closePopup();
    }
  };

  const isSandboxTestTag = () => <Tag type="purple">Sandbox</Tag>;
  const handleMoreFeatureUp = () => {
    const { loadedView } = window;
    if (loadedView && !loadedView.destroyed && loadedView.popup) {
      loadedView.popup.previous();
    }
  };
  const handleMoreFeatureDown = () => {
    const { loadedView } = window;
    if (loadedView && !loadedView.destroyed && loadedView.popup) {
      loadedView.popup.next();
    }
  };

  const featureCount = window.loadedView?.popup?.featureCount || 1;

  return (
    <div className="history-page-map-popup-container">
      {attributes && (
        <>
          <div className="history-page-map-popup-content">
            <div className="id-container">
              <div className="title">
                {!isFullSet && 'JOB'}{' '}
                <span className="external-id">{attributes.external_id}</span>
              </div>
              {featureCount > 1 && (
                <div className="more-feature">
                  <div
                    className="more-feature-up"
                    onClick={handleMoreFeatureUp}
                  >
                    <ChevronUp16 />
                  </div>
                  <div
                    className="more-feature-down"
                    onClick={handleMoreFeatureDown}
                  >
                    <ChevronDown16 />
                  </div>
                </div>
              )}
            </div>
          </div>
          {isFullSet ? (
            <div className="history-page-map-popup-content">
              <div className="heading">Enquirer</div>
              <div>{attributes.user_full_name}</div>
              <div>{attributes.user_email_name}</div>
            </div>
          ) : (
            <div className="history-page-map-popup-content">
              <div className="status">
                {getEnquiryStatusCodeMsg(attributes.status)}
              </div>
            </div>
          )}

          <div className="history-page-map-popup-content">
            {!isFullSet && (
              <>
                <div className="heading">My reference</div>
                <div>{attributes.user_reference}</div>
              </>
            )}
            <div className="heading">Job site</div>
            <div>{attributes.address}</div>
            <div className="heading">Enquiry date</div>
            <div>{Util.toLocalDateTimeFormat(attributes.created_at)}</div>
            {attributes.is_sandbox_test ? (
              <div className="sandbox-tag">{isSandboxTestTag()}</div>
            ) : null}
          </div>
          {isFullSet && (
            <div className="history-page-map-popup-content">
              <div className="heading">Responses (Rec/Total)</div>
              <div>
                {attributes.completed_referral_count}/
                {attributes.total_referral_count}
              </div>
            </div>
          )}
          <div className="history-page-map-popup-content">
            <Button
              className="zoom-btn"
              hasIconOnly
              renderIcon={ZoomIn32}
              kind="tertiary"
              size="field"
              tooltipAlignment="center"
              tooltipPosition="top"
              iconDescription="Zoom in"
              onClick={handleZoomIn}
            />
            <Button
              className="detail-btn"
              kind="tertiary"
              size="field"
              onClick={handleButtonClick}
            >
              View details
            </Button>
          </div>
        </>
      )}
      {!attributes && 'No attributes received'}
    </div>
  );
};

const propTypes = {
  isFullSet: PropTypes.bool,
  attributes: PropTypes.any,
  geometry: PropTypes.any,
  onButtonClick: PropTypes.func
};

type Props = PropTypes.InferProps<typeof propTypes>;

PopUp.defaultProps = {
  attributes: null
};

export default PopUp;

export const PopUpOutFields = [
  'objectid',
  'status',
  'external_id',
  'user_full_name',
  'user_email_name',
  'user_reference',
  'address',
  'created_at',
  'completed_referral_count',
  'total_referral_count'
];
